{
  "version": 1,
  "asset_id": "44e71390-0aea-4ce9-b793-3efa2180d65b",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/44e71390-0aea-4ce9-b793-3efa2180d65b/cp501.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/44e71390-0aea-4ce9-b793-3efa2180d65b/cp501.jpg",
  "original_filename": "cp501.jpg",
  "size": 104547,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:23Z"
}
